const numberFormatter = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

const numberFormatterWithCurrency = (maximumFractionDigits = 2) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits,
    });

export function formatNumber(
    rawNumber: number | string,
    isCurrency = false,
    maximumFractionDigits = 0,
) {
    if (rawNumber === undefined) {
        return rawNumber;
    }

    let temp = rawNumber;
    if (typeof temp === 'string') {
        temp = Number.parseFloat(temp);
    }

    if (isCurrency) {
        return numberFormatterWithCurrency(maximumFractionDigits).format(temp);
    }

    return numberFormatter.format(temp);
}

export const round = (value: number | string, precision: number) => {
    const parsedValue = Number(value);

    // @ts-ignore
    return Number(Math.round(parsedValue + 'e' + precision) + 'e-' + precision);
};

export const formatNumberWithFraction = (v?: any, options: Intl.NumberFormatOptions = {}) => {
    if (!['number', 'string'].includes(typeof v)) return '—';
    return Number(v).toLocaleString('en-US', {minimumFractionDigits: 2, ...options});
};
